/* unplugin-vue-components disabled */import script from "./postReleaseDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./postReleaseDetail.vue?vue&type=script&setup=true&lang=ts"

import "./postReleaseDetail.vue?vue&type=style&index=0&id=3f42fb96&lang=scss&scoped=true"
import "./postReleaseDetail.vue?vue&type=style&index=1&id=3f42fb96&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f42fb96"]])

export default __exports__